@if (activeView !== 'hanger') {
  <div class="image"
    [ngStyle]="{'background-image': 'url(/assets/images/products/frames/' + moulding.code + '/' + activeView + '-screen.jpg)'}">
    <!--
    [ngStyle.gt-md]="{'background-image': 'url(/assets/images/products/frames/' + moulding.code + '/' + activeView + '-large.jpg)'}">
    -->
  </div>
}
@if (activeView === 'hanger') {
  <div class="image"
    [ngStyle]="{'background-image': 'url(/assets/images/products/hangers/' + hangerType + '-screen.jpg)'}">
    <!--
    [ngStyle.gt-md]="{'background-image': 'url(/assets/images/products/hangers/' + hangerType + '-large.jpg)'}">
    -->
  </div>
}

<div class="thumbs">
  @for (view of ['profile','corner','front','back','hanger','spec']; track view) {
    @if (view !== 'hanger') {
      <div class="thumb"
        (click)="setActive(view)" [ngClass]="{active: view == activeView}"
        [style.background-image]="'url(/assets/images/products/frames/' + moulding.code + '/' + view + '-thumb.jpg)'">
      </div>
    }
    @if (view === 'hanger') {
      <div class="thumb"
        (click)="setActive(view)" [ngClass]="{active: view == activeView}"
        [style.background-image]="'url(/assets/images/products/hangers/' + hangerType + '-thumb.jpg)'">
      </div>
    }
  }

</div>

<div class="description" [innerHTML]="partDisplay.description(moulding)">
</div>
